import { ComponentProps } from "react"

import { twMerge } from "tailwind-merge"

import { dataFlag } from "~/src/lib/jsx"

export type TabProps = {
  kind?: "primary" | "secondary"
  selected?: boolean | (() => boolean)
  className?: string
  value?: string
  type?: "button"
} & ComponentProps<"button">

export const primaryStylePresetClass = twMerge(
  "flex border-b border-solid border-transparent py-2 text-nowrap text-gray-500 transition-colors",
  "data-selected:border-gray-900 data-selected:text-gray-900"
)
export const secondaryStylePresetClass = twMerge(
  "align-center flex px-4 py-2 text-nowrap text-gray-900 transition-colors",
  "data-selected:bg-blueslate-200 data-selected:rounded-full"
)

export function Tab(props: TabProps) {
  const { className, selected = false, kind = "primary", ...restProps } = props
  const stylePresetClass = kind != "secondary" ? primaryStylePresetClass : secondaryStylePresetClass

  return (
    <button
      type="button"
      className={twMerge(stylePresetClass, className)}
      {...dataFlag(typeof selected === "boolean" ? selected : selected(), "selected")}
      {...restProps}
    />
  )
}
